import {
  BarChart,
  Bar,
  LineChart,
  Line,
  PieChart,
  Pie,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";

const COLORS = [
  "#3b82f6", "#8b5cf6", "#22c55e", "#f59e0b",
  "#ec4899", "#06b6d4", "#ef4444", "#84cc16",
];

const AXIS_STYLE = { fill: "#9ca3af", fontSize: 12 };

const TOOLTIP_STYLE = {
  contentStyle: {
    backgroundColor: "#111827",
    border: "1px solid #374151",
    borderRadius: "0.75rem",
    color: "#f9fafb",
  },
  labelStyle: { color: "#9ca3af" },
  cursor: { fill: "rgba(255,255,255,0.04)" },
};

export default function DynamicChart({
  data,
  xKey,
  yKey,
  type
}) {

  if (!data?.length) {
    return (
      <div className="h-[300px] flex items-center justify-center text-gray-600 text-sm border border-dashed border-gray-800 rounded-xl">
        No data to visualize yet — ask a question or upload a dataset.
      </div>
    );
  }

  // -----------------------
  // BAR CHART
  // -----------------------
  if (type === "bar") {
    return (
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 8 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#1f2937" vertical={false} />
          <XAxis dataKey={xKey} tick={AXIS_STYLE} axisLine={{ stroke: "#374151" }} tickLine={false} />
          <YAxis tick={AXIS_STYLE} axisLine={{ stroke: "#374151" }} tickLine={false} />
          <Tooltip {...TOOLTIP_STYLE} />
          <Bar dataKey={yKey} radius={[6, 6, 0, 0]}>
            {data.map((_, index) => (
              <Cell key={index} fill={COLORS[index % COLORS.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    );
  }

  // -----------------------
  // LINE CHART (TREND)
  // -----------------------
  if (type === "line") {
    return (
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 8 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#1f2937" vertical={false} />
          <XAxis dataKey={xKey} tick={AXIS_STYLE} axisLine={{ stroke: "#374151" }} tickLine={false} />
          <YAxis tick={AXIS_STYLE} axisLine={{ stroke: "#374151" }} tickLine={false} />
          <Tooltip {...TOOLTIP_STYLE} />
          <Line
            dataKey={yKey}
            stroke="#3b82f6"
            strokeWidth={2.5}
            dot={{ r: 3, fill: "#3b82f6" }}
            activeDot={{ r: 5 }}
          />
        </LineChart>
      </ResponsiveContainer>
    );
  }

  // -----------------------
  // PIE CHART
  // -----------------------
  if (type === "pie") {
    return (
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={data}
            dataKey={yKey}
            nameKey={xKey}
            outerRadius={100}
            innerRadius={55}
            paddingAngle={2}
          >
            {data.map((_, index) => (
              <Cell key={index} fill={COLORS[index % COLORS.length]} stroke="#111827" strokeWidth={2} />
            ))}
          </Pie>
          <Tooltip {...TOOLTIP_STYLE} />
          <Legend wrapperStyle={{ fontSize: 12, color: "#9ca3af" }} />
        </PieChart>
      </ResponsiveContainer>
    );
  }

  return null;
}
